import WithSidePanel from './WithSidePanel';

export default WithSidePanel;

export { useSidePanelSx } from './WithSidePanel';
